// extracted by mini-css-extract-plugin
export default {"dateWrapper":"DashboardPORequestsTable_dateWrapper__MuBoG"};